import './App.css';
import {RoutesWrapper, StepsWrapper} from "./layout/appLayoutStyles";
import Header from "./containers/header/header";
import Form from "./containers/form/form";
import { Route, Switch, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

function App() {
  const { i18n } = useTranslation();


  return (
    <div className="App">
        <RoutesWrapper>
            <div className="agreement">
                <StepsWrapper>
                    <Switch>
                    <Route exact path="/">
                <Redirect to="/ka" />
              </Route>
              <Route path="/:lang(en|ka)">
                    <Header />
                    <Form/>
              </Route>
              <Route path="*">
                <Redirect to="/ka" />
              </Route>
                    <Route path="*">
                <Redirect to="/ka" />
              </Route>
                    </Switch>
                </StepsWrapper>
            </div>
        </RoutesWrapper>
    </div>
  );
}

export default App;
